import React, { useState, useEffect } from 'react'
import { Progress, Collapse, Button, Tabs, Checkbox, Row, Col, Input, Tooltip, Space, InputNumber, Radio, message } from 'antd'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'

import Utils from '../../Utils/utils'
import CountryGrid from '../CountryGrid'
import SectorGrid from '../SectorGrid'
import CollapseHeader from '../CollapseHeader'
import Images from '../../Images'

const { Panel } = Collapse;
const { TabPane } = Tabs;

const investment = {
  enterprise_value: [null, null],
  equity_investment: [null, null],
  equity_stake: [null, null],
  governance: [],
  governance_other: '',
  investment_type: [],
  comment: ''
}

const addInfo = {
  field: 'open_to_being_matched',
  value: null,
};

function InvestorSignUpStep1(props) {
  const {sectorFocus, geographyFocus, equityGovernanceList, investmentTypes, countries, euCountries} = props;

  const [sectorCheckedList, setSectorCheckedList] = useState(null);
  const [sectorCheckAll, setSectorCheckAll] = useState(null);
  const [sectorActiveTab, setSectorActiveTab] = useState(null);
  const [sectorOptions, setSectorOptions] = useState(null);

  const [continentCheckedList, setContinentCheckedList] = useState(null);
  const [continentCheckAll, setContinentCheckAll] = useState(null);
  const [continentActiveTab, setContinentActiveTab] = useState(null);
  const [continentOptions, setContinentOptions] = useState(null);
  const [countryList, setCountryList] = useState(null);

  const [otherSectorText, setOtherSectorText] = useState(null);
  const [otherSectorValue, setOtherSectorValue] = useState(null);
  const [otherSectorList, setOtherSectorList] = useState(null);

  const [investmentSector, setInvestmentSector] = useState(null);
  const [governanceOptions, setGovernanceOptions] = useState(null);
  const [governanceActive, setGovernanceActive] = useState(false);
  const [investmentTypeOptions, setInvestmentTypeOptions] = useState(null);

  const [addInfoValues, setAddInfoValues] = useState(null);

  const [required, setRequired] = useState({
    active: false,
    investment_focus: false,
    sector_focus: false,
    geographic_focus: false
  })

  const history = useHistory();

  useEffect(() => {
    props.getSectors();
    props.getContinents({oecd: true});
    props.getEuCountries(true);
    setInvestmentSector(investment);
    setAddInfoValues(addInfo);
  }, [0]);

  useEffect(() => {
    if (sectorFocus) {
      let sectorsInit = {};
      let sectorsListInit = {};
      let otherSectorsInit = {};
      let options = {};
      sectorFocus.forEach(sector => {
        sectorsInit[sector.name] = false;
        sectorsListInit[sector.name] = [];
        otherSectorsInit[sector.name] = {
          active: false,
          text: '',
          parent: sector.id
        };
        options[sector.name] = sector.children;
      });
      setSectorActiveTab(sectorFocus[0]?.name);
      setOtherSectorList(otherSectorsInit);
      setSectorCheckAll(sectorsInit);
      setSectorCheckedList(sectorsListInit);
      setSectorOptions(options);
    }
  }, [sectorFocus]);

  useEffect(() => {
    if (sectorActiveTab) {
      setOtherSectorValue(null);
      let text = sectorFocus.find(sector => sector.name === sectorActiveTab).other_sector;
      setOtherSectorText(text);
    }
  }, [sectorActiveTab]);

  useEffect(() => {
    if (geographyFocus && countries) {
      let continentsInit = {};
      let continentsListInit = {};
      let options = {};
      let countryList = {};
      countries.forEach(country => {
        countryList[country.id] = [];
      });
      geographyFocus.forEach(continent => {
        continentsInit[continent.name] = false;
        continentsListInit[continent.name] = [];
        options[continent.name] = [];
        for (let i = 0; i < continent.children.length; i++) {
          countryList[continent.children[i].id].push(continent.name);
          options[continent.name].push(
            { label: continent.children[i].name, value: continent.children[i].id },
          );
        }
      });
      setCountryList(countryList);
      setContinentActiveTab(geographyFocus[0]?.name);
      setContinentCheckAll(continentsInit);
      setContinentCheckedList(continentsListInit);
      setContinentOptions(options);
    }
  }, [geographyFocus, countries]);

  useEffect(() => {
    if (equityGovernanceList) {
      const options = [];
      for (let i = 0; i < equityGovernanceList.length; i++) {
        options.push(
          { label: equityGovernanceList[i].name, value: equityGovernanceList[i].id },
        );
      }
      setGovernanceOptions(options);
    }
  }, [equityGovernanceList]);

  useEffect(() => {
    if (investmentTypes) {
      const options = [];
      for (let i = 0; i < investmentTypes.length; i++) {
        options.push(
          { label: investmentTypes[i].name, value: investmentTypes[i].id },
        );
      }
      setInvestmentTypeOptions(options);
    }
  }, [investmentTypes]);

  useEffect(() => {
    if (sectorCheckedList && continentCheckedList && investmentSector && otherSectorList) {
      let checkSectors = Object.values(sectorCheckedList).some(el => el.length);
      let checkOtherSectorsList = Object.values(otherSectorList).filter(el => el.active).every(el => el.text);
      let checkContinents = Object.values(continentCheckedList).some(el => el.length);
      let checkInvestment =
        Utils.checkEmptyValue(investmentSector.enterprise_value) &&
        Utils.checkEmptyValue(investmentSector.equity_investment) &&
        (Utils.checkEmptyValue(investmentSector.equity_stake) && investmentSector.equity_stake.every(el => el > 0 && el < 101)) &&
        investmentSector.investment_type.length > 0;
      if (investmentSector.investment_type.includes(3) && !investmentSector.comment) {
        checkInvestment = false;
      }

      const newData = {
        investment_focus: checkInvestment,
        sector_focus: checkSectors && checkOtherSectorsList,
        geographic_focus: checkContinents,
      };
      setRequired({...required, ...newData});
    }
  }, [sectorCheckedList, continentCheckedList, investmentSector, otherSectorList]);

  useEffect(() => {
    if (investmentSector && governanceActive === false) {
      const newData = {...investmentSector};
      newData.governance_other = null;
      setInvestmentSector(newData);
    }
  }, [governanceActive]);

  const selectCountries = (data, list, activeTab, checkAll) => {
    if (list.length > data[activeTab].length) {
      list.forEach(el => {
        countryList[el].forEach(continent => {
          data[continent].push(el);
        })
      })
    } else {
      const diff = _.difference(data[activeTab], list);
      diff.forEach(el => {
        countryList[el].forEach(continent => {
          data[continent] = _.without(data[continent], el);
          checkAll[continent] = false;
        })
      })
    }
  }

  const onChange = (list, isSector) => {
    if (isSector) {
      const newData = {...sectorCheckedList};
      newData[sectorActiveTab] = list;
      setSectorCheckedList(newData);
    } else {
      const data = _.cloneDeep(continentCheckedList);
      const checkAll = _.cloneDeep(continentCheckAll);

      selectCountries(data, list, continentActiveTab, checkAll);

      data[continentActiveTab] = list;
      setContinentCheckedList(data);
      setContinentCheckAll(checkAll);
    }
  };

  const onCheckAllChange = isSector => {
    if (isSector === true) {
      let dataList = {...sectorCheckedList};
      let dataCheck = {...sectorCheckAll};

      dataList[sectorActiveTab] = !dataCheck[sectorActiveTab] ?
        sectorOptions[sectorActiveTab].map(el => el.children).flat().map(el => el.id)
      :
        []
      dataCheck[sectorActiveTab] = !dataCheck[sectorActiveTab];

      setSectorCheckedList(dataList);
      setSectorCheckAll(dataCheck);
    } else {
      const data =  _.cloneDeep(continentCheckedList);
      let dataList =  _.cloneDeep(continentCheckedList);
      const checkAll = _.cloneDeep(continentCheckAll);

      dataList[continentActiveTab] = !checkAll[continentActiveTab] ?
        continentOptions[continentActiveTab].map(el=>el.value)
      :
        [];

      checkAll[continentActiveTab] = !checkAll[continentActiveTab];

      selectCountries(data, dataList[continentActiveTab], continentActiveTab, checkAll);

      setContinentCheckedList(data);
      setContinentCheckAll(checkAll);
    }
  };

  const onEuropeanChange = () => {
    const data =  _.cloneDeep(continentCheckedList);
    let dataList =  _.cloneDeep(continentCheckedList);
    const checkAll = _.cloneDeep(continentCheckAll);

    dataList[continentActiveTab] = !checkAll[continentActiveTab] ?
      euCountries.map(el=>el.id)
    :
      []

    checkAll[continentActiveTab] = !checkAll[continentActiveTab];

    selectCountries(data, dataList[continentActiveTab], continentActiveTab, checkAll);

    setContinentCheckedList(data);
    setContinentCheckAll(checkAll);
  };

  const changeOtherSector = e => {
    const newData = {...otherSectorList};
    newData[sectorActiveTab].active = e.target.checked;
    setOtherSectorList(newData);
  }

  const changeSpecValue = e => {
    const newData = {...otherSectorList};
    newData[sectorActiveTab].text = e.target.value;
    setOtherSectorList(newData);
  }

  const changeInvestmentRange = (e, position, field) => {
    if (e.target.value !== '') {
      const newData = {...investmentSector};
      newData[field][position] = Number(e.target.value);
      if (typeof newData[field][1] === 'number' && newData[field][0] > newData[field][1]) {
        newData[field][0] = newData[field][1];
      }
      setInvestmentSector(newData);
    }
  }

  const changeInvestmentCheck = list => {
    const newData = {...investmentSector};
    newData.governance = list;
    setInvestmentSector(newData);
  }

  const changeInvestmentOtherInput = e => {
    const newData = {...investmentSector};
    newData.governance_other = e.target.value;
    setInvestmentSector(newData);
  }

  const changeAddInfoValue = value => {
    const newData = {...addInfoValues};
    newData.value = value;
    setAddInfoValues(newData);
  }

  const changeInvestmentType = list => {
    const newData = {...investmentSector};
    newData.investment_type = list;
    setInvestmentSector(newData);
  }
  const changeComment = value => {
    const newData = {...investmentSector};
    newData.comment = value;
    setInvestmentSector(newData);
  }

  const checkRequiredFields = () => {
    let checkSectors = Object.values(sectorCheckedList).some(el => el.length);
    let checkOtherSectorsList = Object.values(otherSectorList).filter(el => el.active).every(el => el.text);
    let checkContinents = Object.values(continentCheckedList).some(el => el.length);
    let checkInvestment =
        Utils.checkEmptyValue(investmentSector.enterprise_value) &&
        Utils.checkEmptyValue(investmentSector.equity_investment) &&
        (Utils.checkEmptyValue(investmentSector.equity_stake) && investmentSector.equity_stake.every(el => el > 0 && el < 101)) &&
        investmentSector.investment_type.length > 0;
    if (investmentSector.investment_type?.includes(3) && !investmentSector.comment) {
      checkInvestment = false;
    }

    const newData = {
      active: true,
      investment_focus: checkInvestment,
      sector_focus: checkSectors && checkOtherSectorsList,
      geographic_focus: checkContinents,
    };
    setRequired({...required, ...newData});

    if (checkSectors && checkContinents && checkInvestment && checkOtherSectorsList) {
      const totalData = {
        industry_focus_sub_sectors: Object.values(sectorCheckedList).flat(),
        countries: Object.values(continentCheckedList).flat(),
        additional_specification: Object.values(otherSectorList).flat().map(el => ({
          name: el.text,
          parent: el.parent
        })),
        investment_focus: {
          enterprise_value_from: investmentSector.enterprise_value[0],
          enterprise_value_to: investmentSector.enterprise_value[1],
          equity_investment_from: investmentSector.equity_investment[0],
          equity_investment_to: investmentSector.equity_investment[1],
          equity_stake_from: investmentSector.equity_stake[0],
          equity_stake_to: investmentSector.equity_stake[1],
          governace_of_the_targeted_equity: investmentSector.governance,
          specified_governace: governanceActive ? investmentSector.governance_other : null,
          investment_type: investmentSector.investment_type,
          comment: investmentSector.investment_type.includes(3) ? investmentSector.comment : null
        },
        open_to_being_matched: {
          value: addInfoValues.value,
          text: null
        }
      };
      props.onChangeStep(totalData)
    } else {
      message.error('All fields must be filled in to proceed', 3);
    }
  }

  return (
    <div className="sign-up-step white">
      <img src={Images.logo} alt="" onClick={()=>history.push('/')} />
      <div className="step-investor-content">
        <div className="step-title">Company Onboarding</div>
        <div className="step-number">Step 1 - Matching filters</div>
        <div style={{width: 520}}>
          <Progress
            percent={33}
            showInfo={false}
            strokeWidth={13}
            trailColor="rgba(31, 73, 228, 0.12)"
            strokeColor="#3680F6"
            status="active"
          />
        </div>
        <div className="step-text">Please fill in the fields below so we can notify your firm when a relevant investment opportunity is shared on the platform.<br />As a Lead Investor you will be notified about any new deal opportunities matching your firm’s filters.</div>
      </div>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) =>
          isActive ?
            <img src={Images.angleUp} alt="" />
            :
            <img src={Images.angleDown} alt="" />
        }
        expandIconPosition="right"
        className="site-collapse-custom-collapse"
        accordion
      >
        <Panel
          header={<CollapseHeader text="Investment focus" imageType="coins" />} key="investment"
          className={`site-collapse-custom-panel${(required.active && !required.investment_focus) ? ' error-block' : ''}`}
        >
          <div>
            <div className="collapse-content-title">Please indicate the size and type of the investment opportunities your firm is targeting</div>
            <div className="investment-range">
              <div className="investment-range-title">Enterprise value</div>
              <div className="investment-range-data">
                <span>Range (ml)</span>
                <div className="investment-range-label">From</div>
                <InputNumber
                  min={0}
                  max={99999}
                  placeholder="...ml"
                  parser={value => Number(value).toFixed()}
                  value={investmentSector?.enterprise_value[0]}
                  onBlur={(e)=>changeInvestmentRange(e, 0, 'enterprise_value')}
                />
                <div className="investment-range-label">To</div>
                <InputNumber
                  min={0}
                  max={99999}
                  placeholder="...ml"
                  parser={value => Number(value).toFixed()}
                  value={investmentSector?.enterprise_value[1]}
                  onBlur={(e)=>changeInvestmentRange(e, 1, 'enterprise_value')}
                />
                <span>[in £]</span>
              </div>
            </div>
            <div className="investment-range">
              <div className="investment-range-title">Equity ticket</div>
              <div className="investment-range-data">
                <span>Range (ml)</span>
                <div className="investment-range-label">From</div>
                <InputNumber
                  min={0}
                  max={99999}
                  placeholder="...ml"
                  parser={value => Number(value).toFixed()}
                  value={investmentSector?.equity_investment[0]}
                  onBlur={(e)=>changeInvestmentRange(e, 0, 'equity_investment')}
                />

                <div className="investment-range-label">To</div>
                <InputNumber
                  min={0}
                  max={99999}
                  placeholder="...ml"
                  parser={value => Number(value).toFixed()}
                  value={investmentSector?.equity_investment[1]}
                  onBlur={(e)=>changeInvestmentRange(e, 1, 'equity_investment')}
                />
                <span>[in £]</span>
              </div>
            </div>
            <div className="investment-range">
              <div className="investment-range-title">Equity stake</div>
              <div className="investment-range-data">
                <span className="percent-span">Range (%)</span>
                <div className="investment-range-label">From</div>
                <InputNumber
                  min={1}
                  max={100}
                  placeholder="%"
                  parser={value => Number(value).toFixed()}
                  value={investmentSector?.equity_stake[0]}
                  onBlur={(e)=>changeInvestmentRange(e, 0, 'equity_stake')}
                />

                <div className="investment-range-label">To</div>
                <InputNumber
                  min={1}
                  max={100}
                  placeholder="%"
                  parser={value => Number(value).toFixed()}
                  value={investmentSector?.equity_stake[1]}
                  onBlur={(e)=>changeInvestmentRange(e, 1, 'equity_stake')}
                />
              </div>
            </div>
            <div className="investment-range base">
              <div className="investment-range-title">
                <div>Governance of the targeted equity</div>
                <span>(Select all applicable)</span>
              </div>
              <div className="investment-range-check">
                <Checkbox.Group
                  value={investmentSector?.governance}
                  onChange={(list)=>changeInvestmentCheck(list)}
                >
                  <Row gutter={[16, 30]}  style={{marginBottom: 24}}>
                    {
                      governanceOptions && governanceOptions?.map(option => (
                        <Col span={12} key={option.value}>
                          <Checkbox value={option.value}>{option.label}</Checkbox>
                        </Col>
                      ))
                    }
                  </Row>
                </Checkbox.Group>
                <Row gutter={[16, 30]} style={{marginBottom: 0}}>
                  <Col span={8} style={{display: 'flex', alignItems: 'center'}}>
                    <Checkbox onChange={(e)=>setGovernanceActive(e.target.checked)}>Other</Checkbox>
                  </Col>
                  <Col span={16}>
                    <Input
                      placeholder="Please Specify…"
                      maxLength={100}
                      disabled={!governanceActive}
                      onBlur={changeInvestmentOtherInput}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <div className="investment-range base" style={{borderBottom: 'none'}}>
              <div className="investment-range-title">
                <div>Investment type</div>
                <span>(Select all applicable)</span>
              </div>
              <div className="investment-range-check">
                <Checkbox.Group
                  style={{width: '100%'}}
                  value={investmentSector?.investment_type}
                  onChange={changeInvestmentType}
                >
                  <Row gutter={[16, 30]}>
                    {
                      investmentTypeOptions && investmentTypeOptions?.map(option => (
                        <Col span={8} key={option.value}>
                          <Checkbox value={option.value}>{option.label}</Checkbox>
                        </Col>
                      ))
                    }
                  </Row>
                </Checkbox.Group>

                {
                  (investmentSector && investmentSector.investment_type.includes(3)) &&
                    <div className="investment-range base" style={{marginTop: 16, padding: 0}}>
                      <Row gutter={[16, 0]} style={{width: '100%'}}>
                        <Col span={24}>
                          <Input
                            className={investmentSector && investmentSector.investment_type.includes(3) && !investmentSector.comment ? 'error-input' : ''}
                            placeholder="Please Specify…"
                            maxLength={100}
                            defaultValue={investmentSector.comment}
                            onBlur={e=>changeComment(e.target.value)}
                          />
                        </Col>
                      </Row>
                      </div>
                }
              </div>

            </div>
          </div>
        </Panel>
        <Panel
          header={<CollapseHeader text="Sector Focus" imageType="puzzle" />} key="sector"
          className={`site-collapse-custom-panel${(required.active && !required.sector_focus) ? ' error-block' : ''}`}
        >
          <div>
            <div className="collapse-content-title">Please indicate the sectors and related sub-sectors in which your firm can consider investment opportunities</div>
            <div className="tabs-content">
              <div className="tabs-header">
                <div style={{width: 300}}>Sectors</div>
                <div style={{width: 'auto'}}>Sub Sectors</div>
                <span onClick={() => onCheckAllChange(true)}>{sectorCheckAll && sectorCheckAll[sectorActiveTab] ? 'Unselect all' : 'Select all'}</span>
              </div>
              <Tabs tabPosition="left" onChange={(key) => setSectorActiveTab(key)} activeKey={sectorActiveTab}>
                {
                  sectorCheckedList && sectorFocus?.map(sector =>(
                    <TabPane tab={sector.name} key={sector.name}>
                      <div className="vertical-tab-line"></div>
                      <Checkbox.Group value={sectorCheckedList[sector.name]} onChange={(list)=>onChange(list, true)}>
                        <SectorGrid
                          data={sectorOptions[sector.name]}
                        />
                      </Checkbox.Group>
                    </TabPane>
                  ))
                }
              </Tabs>
              <div className="divider" style={{height: 7, margin: '24px 0 16px'}}></div>
              <Row gutter={[16, 24]}>
                <Col span={12} offset={12}>
                  <Checkbox
                    checked={otherSectorList && otherSectorList[sectorActiveTab].active}
                    onChange={e=>changeOtherSector(e)}
                  >
                    {otherSectorText}
                  </Checkbox>
                </Col>
              </Row>
                {
                  ((sectorCheckedList && sectorCheckedList[sectorActiveTab].length > 0) || (otherSectorList && otherSectorList[sectorActiveTab].active)) &&
                    <Row gutter={[16, 24]} style={{marginTop: 16}}>
                      <Col span={12}>
                        <div className="add-spec">Additional sector specification</div>
                      </Col>
                      <Col span={12} className="flex-center-vertical">
                        <Input
                          className={otherSectorList[sectorActiveTab].active && !otherSectorList[sectorActiveTab].text ? 'error-input' : ''}
                          placeholder="Please include any additional specification"
                          maxLength={180}
                          value={otherSectorValue != null ? otherSectorValue : otherSectorList[sectorActiveTab].text}
                          onChange={e=>setOtherSectorValue(e.target.value)}
                          onBlur={e=>changeSpecValue(e)}
                        />
                      </Col>
                    </Row>
                }
              <Row gutter={[16, 24]} style={{marginTop: 16}}>
                <Col span={12} style={{fontWeight: 500}}>Are you open to being matched to and consider opportunities in sub-sectors not yet classified?</Col>
                <Col span={12}>
                  <Radio.Group onChange={(e)=>changeAddInfoValue(e.target.value)}>
                    <Radio value={true}>Yes</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </div>
          </div>
        </Panel>
        <Panel
          header={<CollapseHeader text="Geographic Focus" imageType="globe" />} key="geography"
          className={`site-collapse-custom-panel${(required.active && !required.geographic_focus) ? ' error-block' : ''}`}
        >
          <div>
            <div className="collapse-content-title">Please indicate the continent/countries in which your firm can consider investment opportunities</div>
            <div className="tabs-content">
              <div className="tabs-header">
                <div>Area</div>
                <div>Countries</div>
                {
                  continentActiveTab === 'Europe' ?
                    <span onClick={onEuropeanChange}>Select all European Union countries</span>
                  :
                    <span onClick={onCheckAllChange}>{continentCheckAll && continentCheckAll[continentActiveTab] ? 'Unselect all' : 'Select all'}</span>
                }
              </div>
              <Tabs tabPosition="left" onChange={(key) => setContinentActiveTab(key)} activeKey={continentActiveTab}>
                {
                  continentCheckedList && geographyFocus.map(continent =>(
                    <TabPane tab={continent.name} key={continent.name}>
                      <div className="vertical-tab-line"></div>
                      <Checkbox.Group value={continentCheckedList[continent.name]} onChange={onChange}>
                        <CountryGrid
                          data={continentOptions[continent.name]}
                        />
                      </Checkbox.Group>
                    </TabPane>
                  ))
                }
              </Tabs>
            </div>
          </div>
        </Panel>
      </Collapse>
      <Button type="primary" className="btn-primary" style={{ width: 217, marginTop: 58 }}  onClick={checkRequiredFields}>
        Continue
        </Button>
    </div>
  )
}

export default InvestorSignUpStep1
